import { ExternalLink } from 'shared/components/ExternalLink/ExternalLink'

const ONBOARDING_WEBINAR_PLACEHOLDER_URL = 'https://go.cloudtrucks.com/OnboardingWebinarRegistration.html'

export function OnboardingCallButton() {
  return <ExternalLink href={ONBOARDING_WEBINAR_PLACEHOLDER_URL}>Schedule</ExternalLink>
}
